<template>
    <div class="ah-data-card outsourcing-person-account-data-card" :class="{ loading: isLoading }">
        <div style="display: flex; justify-content: space-between">
            <div class="header-name">
                <span>{{ loadedData.fnam }}</span>
                <span v-if="loadedData.abd === 1" style="display: inline-block; margin-left: 10px; font-size: 10pt">(外國籍)</span>
            </div>
            <div>
                <el-tooltip :manual="isAuth('C03')" effect="light" content="您沒有「請款委外管理」權限" placement="top-end">
                    <el-button v-if="showEditButton" size="mini" icon="el-icon-edit" :disabled="isLoading || !isAuth('C03') || isQR()" @click="onEditButtonClick">編輯</el-button>
                </el-tooltip>
            </div>
        </div>
        <div class="ah-info-data-list">
            <div class="item">
                <div class="label">帳戶類型</div>
                <div class="value">
                    {{ loadedData.accountType === 1 ? "本國帳戶" : "外國帳戶" }}
                </div>
            </div>
            <div v-if="loadedData.accountType === 1" class="item">
                <div class="label">收款銀行-分行</div>
                <div class="value">
                    <div>{{ bankTxt }} ({{ loadedData.bnK_BOO }})</div>
                    <div>分行代碼：{{ loadedData.bnK_DOO }}</div>
                </div>
            </div>
            <div v-if="loadedData.accountType === 2" class="item">
                <div class="label">收款銀行名稱（英文）</div>
                <div class="value">{{ loadedData.abroadBankName }}</div>
            </div>
            <div v-if="loadedData.accountType === 2" class="item">
                <div class="label">SWIFT Code</div>
                <div class="value">{{ loadedData.swiftCode }}</div>
            </div>
            <div class="item">
                <div class="label">存摺戶名</div>
                <div class="value">{{ loadedData.bnK_TPC }}</div>
            </div>
            <div class="item">
                <div class="label">收款帳號</div>
                <div class="value">{{ loadedData.bnK_ACC }}</div>
            </div>
            <div class="item">
                <div class="label">收款帳戶存摺封面</div>
                <div class="value">
                    <el-image v-if="loadedData.passbookDoc" :src="loadedData.passbookDoc" :previewSrcList="[loadedData.passbookDoc]" style="width: 100px; height: 70px" fit="contain"></el-image>
                    <span v-else> -- </span>
                </div>
            </div>
        </div>
        <person-upsert-dialog :visible="upsertDialog.visible" :sno="osSno" @close="onUpsertDialogClose" />
    </div>
</template>
<script>
import _ from 'lodash';
import PersonUpsertDialog from '../PersonUpsertDialog/UpsertDialog.vue';

export default {
    name: 'outsourcing-person-account-data-card',
    components: { PersonUpsertDialog },
    props: {
        osSno: {
            type: Number,
            default: null,
        },
        sno: {
            type: Number,
            default: null,
        },
        bnkList: {
            type: Array,
            default: () => [],
        },
        showEditButton: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        loadedData() {
            return _.find(this.bnkList, ['sno', this.sno]);
        },
        bankTxt() {
            return _.find(this.dooList, ['doo', this.loadedData.bnK_DOO])?.nam;
        },
    },
    data() {
        return {
            isLoading: false,

            // 編輯視窗
            upsertDialog: {
                visible: false,
            },

            dooList: [],
        };
    },
    mounted() {
        this.fetchBranchList(this.loadedData.bnK_BOO);
    },
    methods: {
        async fetchBranchList(boo) {
            if (!boo) return;

            const resp = await this.$api({
                url: `/Tool/GetBranchOptions?BOO=${boo}`,
                method: 'GET',
            });
            this.dooList = resp.data.options;
        },
        // 按下編輯
        onEditButtonClick() {
            this.upsertDialog.visible = true;
        },

        // 編輯視窗關閉
        onUpsertDialogClose(refresh) {
            this.upsertDialog.visible = false;
            if (refresh) this.$emit('refresh');
        },
    },
};
</script>
<style lang="scss">
</style>
